var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeelaxoLogoMarkRoundDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276.52 276.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 138.26,
    cy: 138.26,
    r: 136.76
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.15,70.99c0,11.54-9.36,20.9-20.9,20.9s-20.91-9.37-20.91-20.9,9.36-20.91,20.91-20.91,20.9,9.37,20.9,20.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.39,214.22c.58-.24.87-.9.63-1.48l-18.55-45.62c-.24-.58-.62-1.54-.83-2.12l-2.44-6.38c-.23-.58-.89-.88-1.47-.66l-58.42,22.32c-.58.23-1.24-.07-1.47-.66L92.01,49.27c-.23-.58-.89-.88-1.47-.66l-38.4,14.69c-.58.23-.88.89-.66,1.47l62.11,162.48c.23.58.89.88,1.47.65l74.64-29.4c.58-.23,1.25.06,1.49.64l9.5,23.51c.24.58.9.87,1.48.63l22.24-9.05h-.02,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelaxoLogoMarkRoundDark);
export default __webpack_public_path__ + "static/media/feelaxo-logo-mark-round-dark.ee7d677bb4fa05ad11061b406dbfbed7.svg";
export { ForwardRef as ReactComponent };